import { render, staticRenderFns } from "./StrPermissionTree.vue?vue&type=template&id=91a47dc8&scoped=true"
import script from "./StrPermissionTree.vue?vue&type=script&lang=js"
export * from "./StrPermissionTree.vue?vue&type=script&lang=js"
import style0 from "./StrPermissionTree.vue?vue&type=style&index=0&id=91a47dc8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a47dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91a47dc8')) {
      api.createRecord('91a47dc8', component.options)
    } else {
      api.reload('91a47dc8', component.options)
    }
    module.hot.accept("./StrPermissionTree.vue?vue&type=template&id=91a47dc8&scoped=true", function () {
      api.rerender('91a47dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/positionManage/components/StrPermissionTree.vue"
export default component.exports